import { api } from "@/builders/axios";
import {
  ContentsData,
  ContentsList,
  CreateContent,
} from "@/builders/types/contents";

import { id } from "./id";

type Params = {
  page?: number;
  chapter?: number;
};

const get = function (params: Params = {}) {
  return api.get<ContentsList>("contents", { params }).then(({ data }) => data);
};

const post = function (data: CreateContent) {
  return api
    .post<{ data: ContentsData }>("contents", data)
    .then(({ data }) => data);
};

export const contents = {
  get,
  post,
  id,
};
